__turbopack_context__.v({
  "card": "ProductCard-module-scss-module__hCtJ2G__card",
  "flavor": "ProductCard-module-scss-module__hCtJ2G__flavor",
  "hoverImage": "ProductCard-module-scss-module__hCtJ2G__hoverImage",
  "imageWrap": "ProductCard-module-scss-module__hCtJ2G__imageWrap",
  "info": "ProductCard-module-scss-module__hCtJ2G__info",
  "mainImage": "ProductCard-module-scss-module__hCtJ2G__mainImage",
  "meta": "ProductCard-module-scss-module__hCtJ2G__meta",
  "name": "ProductCard-module-scss-module__hCtJ2G__name",
  "price": "ProductCard-module-scss-module__hCtJ2G__price",
  "roast": "ProductCard-module-scss-module__hCtJ2G__roast",
});
